/* global window */

const createStorageManager = KEY => ({
  get: () => window.localStorage.getItem(KEY),
  set: token => window.localStorage.setItem(KEY, token),
  clear: () => window.localStorage.removeItem(KEY),
})

export default createStorageManager('rr_token')



// WEBPACK FOOTER //
// ./src/services/token-storage.js